import ICurrentUserState from './ICurrentUserState';

export enum ISingleEmpPersDetailsActionTypes {
    FETCH_EMP_PERSONAL_DETAILS_LIST_REQUEST = 'FETCH_EMP_PERSONAL_DETAILS_LIST_REQUEST',
    FETCH_EMP_PERSONAL_DETAILS_LIST_SUCCESS = 'FETCH_EMP_PERSONAL_DETAILS_LIST_SUCCESS',
    FETCH_EMP_PERSONAL_DETAILS_LIST_FAILURE = 'FETCH_EMP_PERSONAL_DETAILS_LIST_FAILURE',

}

export type ISingleEmpPersDetailsActionCreator = {
    type: string;
    payload: ICurrentUserState;
  };
